import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { SiteState } from 'src/app/shared/models';

import * as CopyAdviceSelectors from '../../store/copy-advice.selectors';

@Component({
  selector: 'app-copy-advice-progress',
  templateUrl: './copy-advice-progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CopyAdviceProgressComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  percentage$ = this.store.pipe(select(CopyAdviceSelectors.selectCopyPercentage));
  copying$ = this.store.pipe(select(CopyAdviceSelectors.selectAmountCopying));
  completed$ = this.store.pipe(select(CopyAdviceSelectors.selectAmountCompleted));
}
